import {LexicalEditor} from 'lexical';
import {TEmailContextType} from './types';
import {TPersonalizeStates} from '../components/SideBar/parts/Personalize/hooks/types';
import {THyperlinkStates} from '../components/SideBar/parts/Hyperlink/hooks/types';
import {TreeNodeProps} from '@priority-software/priority-style-react';

type Action<T, P = undefined> = {
    type: T;
    payload?: P;
};

export enum ActionTypes {
    OPEN_EMAILEDITOR = 'OPEN_EMAILEDITOR',
    CLOSE_EMAILEDITOR = 'CLOSE_EMAILEDITOR',
    SAVE_EMAILEDITOR = 'SAVE_EMAILEDITOR',
    PERSONALIZE_UPDATE = 'PERSONALIZE_UPDATE',
    HYPERLINK_UPDATE = 'HYPERLINK_UPDATE',
    HYPERLINK_STATES_UPDATE = 'HYPERLINK_STATES_UPDATE',
    HYPERLINK_ACTIVE_UPDATE = 'HYPERLINK_ACTIVE_UPDATE',
    IMAGE_UPDATE = 'IMAGE_UPDATE',
    LANGUAGE_UPDATE = 'LANGUAGE_UPDATE',
    DISPATCH_STATE = 'DISPATCH_STATE',
    UPDATE_EMAIL_EDITOR = 'UPDATE_EMAIL_EDITOR',
    UPDATE_EMAIL_HTML = 'UPDATE_EMAIL_HTML',
    UPDATE_EMAIL_SUBJECT = 'UPDATE_EMAIL_SUBJECT',
    UPDATE_EMAIL_SUBJECT_IDS = 'UPDATE_EMAIL_SUBJECT_IDS',
    UPDATE_DIRTY_STATE = 'UPDATE_DIRTY_STATE',
    UPDATE_AI_LOADING_STATE = 'UPDATE_AI_LOADING_STATE'
}

type CloseEmailEditorAction = Action<ActionTypes.CLOSE_EMAILEDITOR>;

type OpenEmailEditorAction = Action<ActionTypes.OPEN_EMAILEDITOR>;

type SaveEmailEditorAction = Action<ActionTypes.SAVE_EMAILEDITOR>;

type PersonalizeUpdateAction = Action<
    ActionTypes.PERSONALIZE_UPDATE,
    {personalizeState: TPersonalizeStates}
>;

type HyperLinkUpdateAction = Action<ActionTypes.HYPERLINK_UPDATE>;

type HyperlinkStatesUpdateAction = Action<
    ActionTypes.HYPERLINK_STATES_UPDATE,
    {hyperlinkStates: THyperlinkStates}
>;
type HyperlinkActiveUpdateAction = Action<ActionTypes.HYPERLINK_ACTIVE_UPDATE, {isActive: boolean}>;

type ImageUpdateAction = Action<ActionTypes.IMAGE_UPDATE, {imageState: string}>;

type LanguageAction = Action<ActionTypes.LANGUAGE_UPDATE, {language: string}>;

type UpdateEmailEditorAction = Action<ActionTypes.UPDATE_EMAIL_EDITOR, {editor: LexicalEditor}>;

type UpdateEmailHtmlAction = Action<ActionTypes.UPDATE_EMAIL_HTML, {emailHtml: string}>;

type UpdateEmailSubjectAction = Action<ActionTypes.UPDATE_EMAIL_SUBJECT, {subject: string}>;

type UpdateDirtyStateAction = Action<ActionTypes.UPDATE_DIRTY_STATE, {isDirty: boolean}>;

type UpdateAILoadingStateAction = Action<ActionTypes.UPDATE_AI_LOADING_STATE, {aiLoading: boolean}>;

type UPDATE_EMAIL_SUBJECT_IDS = Action<
    ActionTypes.UPDATE_EMAIL_SUBJECT_IDS,
    {subject: string; treeValues: TreeNodeProps}
>;

type DispatchStateAction = Action<ActionTypes.DISPATCH_STATE, Partial<TEmailContextType>>;

export type EmailActions =
    | CloseEmailEditorAction
    | OpenEmailEditorAction
    | SaveEmailEditorAction
    | PersonalizeUpdateAction
    | HyperLinkUpdateAction
    | HyperlinkStatesUpdateAction
    | HyperlinkActiveUpdateAction
    | ImageUpdateAction
    | LanguageAction
    | UpdateEmailEditorAction
    | UpdateEmailHtmlAction
    | UpdateEmailSubjectAction
    | UPDATE_EMAIL_SUBJECT_IDS
    | UpdateDirtyStateAction
    | DispatchStateAction
    | UpdateAILoadingStateAction;
